import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Alert, Container, Row, Col, Button } from 'react-bootstrap';

function InvitationError() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const errorType = queryParams.get('error') || 'unknown';
  
  // Define error messages based on error type
  const getErrorMessage = () => {
    switch (errorType) {
      case 'invalid':
        return "Povezava za vabilo je neveljavna ali je bila že uporabljena.";
      case 'expired':
        return "Vabilo je poteklo. Prosi za novo vabilo.";
      case 'server':
        return "Prišlo je do težave pri obdelavi tvojega vabila. Poskusi znova kasneje.";
      default:
        return "Prišlo je do težave s povezavo za vabilo.";
    }
  };
  
  return (
    <Container className="mt-5">
      <div className="text-center mb-4">
        <img 
          src="/MUSI.ico" 
          alt="MUSI Logo" 
          className="img-fluid" 
          style={{ maxHeight: '120px' }} 
        />
        <h2 className="mt-3">MUSI</h2>
      </div>
      <Row className="justify-content-center">
        <Col md={6}>
          <Alert variant="danger" className="shadow-sm">
            <Alert.Heading className="text-center">Napaka pri vabilu</Alert.Heading>
            <p className="text-center mb-4">
              {getErrorMessage()}
            </p>
            
            <div className="d-flex justify-content-center gap-3">
              <Link to="/">
                <Button variant="primary">
                  Pojdi na domačo stran
                </Button>
              </Link>
              
              <Link to="/login">
                <Button variant="outline-secondary">
                  Prijava
                </Button>
              </Link>
            </div>
          </Alert>
          
          <div className="mt-3 text-center">
            <p>Nimaš računa? <Link to="/register">Registriraj se tukaj</Link></p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default InvitationError;